module.exports = __webpack_public_path__ + "static/media/noCard.f7bc3a28.svg";